// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  AppleDeviceNameCapitaliser
// -----------------------------------------------------------

const devices = [/^ipad/i, /^iphone/i, /^ipod/i];

function determineClass(i, word) {
  switch (i) {
    case 0:
      return 'text-lowercase';
    case 1:
      return 'text-uppercase';
    default:
      if (word.substring(i - 2, i + 1).match(/^ X\S/i)) {
        // this non-whitespace character was preceded with a space and an 'X'
        return 'text-uppercase';
      }

      break;
  }
}

function capitalize(word) {
  return [].map.call(word, (character, i) => (
    <span key={i} className={determineClass(i, word)}>
      {character}
    </span>
  ));
}

const AppleDeviceNameCapitaliser = ({ children: text }) => {
  if (typeof text !== 'string') {
    return text;
  }

  return (
    <span>
      {devices.some((device) => text.match(device)) ? capitalize(text) : text}
    </span>
  );
};

export default AppleDeviceNameCapitaliser;
